<template>
    <div class="" style="">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">园区动态</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="commonTabContent e-flex">
        <div class="commonTabCenter e-flex">
          <div v-for="(item, index) in tabs" :class="'commonTab ' + (index == tabIndex ? 'commonTabActive' : '')" @click="changeTab(item, index)">{{ item.name }}</div>
        </div>
      </div>
      <div class="pd_listContent">
        <div class="pd_listContentFlex">
          <div class="pd_list e-flex" style="justify-content: flex-start;" v-for="(item, index) in list" v-if="index % 2 == 0">
            <div class="pd_listWhite" @click="goDetailPD(item.id)">
              <div class="parkDynamicRightList e-flex bottomNone">
                <div class="dateContent" style="min-width: 43px !important;">
                  <div class="date">{{ item.publishDate.slice(8,10) }}</div>
                  <div class="yearMonth">{{ item.publishDate.slice(0,7) }}</div>
                </div>
                <div class="parkDynamicRightCommon flexAll">{{ item.title }}</div>
                <!-- <img class="parkDynamicRightImg" :src="item.thumbUrl"> -->
              </div>
            </div>
            <div class="pd_listWhite e-flex pd_ml20" v-if="list[index + 1]" @click="goDetailPD(list[index + 1].id)">
              <div class="parkDynamicRightList e-flex bottomNone">
                <div class="dateContent" style="min-width: 43px !important;">
                  <div class="date">{{ list[index + 1].publishDate.slice(8,10) }}</div>
                  <div class="yearMonth">{{ list[index + 1].publishDate.slice(0,7) }}</div>
                </div>
                <div class="parkDynamicRightCommon flexAll">{{ list[index + 1].title }}</div>
                <!-- <img class="parkDynamicRightImg" :src="list[index + 1].thumbUrl"> -->
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="noDataContent" v-if="list.length == 0">
          <img class="noDataImg" src="@/assets/images/noDataImg.png">
          <div class="noDataText">暂无内容</div>
      </div>
      <div class="e-flex pd_paginationContent">
        <el-pagination background layout="prev, pager, next, jumper" :page-size="10" :total="recordsTotal" @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </template>
  
  <script>
    import '../../styles/parkDynamics.css'
    export default {
      name: 'parkDynamics',
      data () {
        return {
          tabs: [{
            name: '全部分类',
            id: ''
          }],
          tabIndex: 0,
          page: 1,
          recordsTotal: 0,
          list: []
        }
      },
      created() {
        this.getQueryCategoryList()
      },
      methods: {
        changeTab(item, index) {
          this.tabIndex = index
          this.getData()
        },
        pageChange(e) {
          this.page = e
          this.getData()
        },
        goDetailPD(id) {
          this.$router.push({ path: '/parkDynamics/detail', query: {id: id}})
        },
        getQueryCategoryList() {
          this.request({
            url: 'baseInfo/infoCategoryList?page=1&limit=100',
            method: 'get',
            data: {}
          }).then(res => {
            this.tabs = this.tabs.concat(res.data)
            this.getData()
          })
        },
        getData() {
          this.request({
            url: 'info/list?page=' + this.page + '&limit=10&categoryId=' + this.tabs[this.tabIndex].id,
            method: 'get',
            data: {}
          }).then(res => {
            this.recordsTotal = res.recordsTotal
            this.list = res.data
          })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/parkDynamics/index.vue